import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import { Box, Typography, TextField } from '@mui/material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { customerService } from '../../services/CustomerServices'
import Urls from '../../utils/urlEnlightenStrings'
import Icon from '../../utils/icons'
import { AppButton, CustomDialog, Cards } from '../../components'
import { PROGRAM_KEY, FAMILY_KEY, PROGRAM_WORKFLOW } from '../../constants/common'
import ApplicationFooter from './ApplicationFooter'
import FormFields from './FormFields'
import PdfViewer from './PdfViewer'
import { getFormFields, getFormDetails, STATUS, SITE_STATUS, FORM_IDS } from './constants'
import { useStyles } from './style'
import { downloadFile } from '../../utils/fileUtils'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'

function ApplicationDetails(props) {
  const classes = useStyles()
  const [forms, setForms] = useState([])
  const [pdfList, setPdfList] = useState([])
  const [selectedPdf, setPdfUrl] = useState({})
  const [length, setLength] = useState(-1)
  const [disableButton, setButtonDisable] = useState(true)
  const [approveModal, setApproveModal] = useState(false)
  const [rejectModal, setRejectModal] = useState(false)
  const [reason, setReason] = useState('')
  const [showReasonModal, setShowReason] = useState(false)
  const [showErrorModal, setErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [psegReferenceId, setPsegReferenceId] = useState('')
  const [formFields, setFormFields] = useState([])

  useEffect(async () => {
    if (props.programKey || props.familyKey) {
      const response = await getFormFields(props.programKey, props.familyKey)
      setFormFields(response)
    }
  }, [props.programKey, props.familyKey])

  useEffect(() => {
    setPsegReferenceId('')
  }, [props.applicationId])

  useEffect(async () => {
    let list = []
    let forms = []
    let key = props.familyKey ? props.familyKey : props.programKey
    switch (key) {
      case PROGRAM_KEY.APS_RBP: {
        list = [
          { fileName: 'Program T&C Document', fileUrl: _.get(props.applicationDetails, 'signed_tandc_form_downloadable_url', '') }
        ]
        break
      }
      case PROGRAM_KEY.SWELL: {
        list = [
          { fileName: 'Program T&C Document', fileUrl: _.get(props.applicationDetails, 'signed_tandc_form_downloadable_url', '') },
          { fileName: 'Application Form', fileUrl: _.get(props.applicationDetails, 'signed_application_form_downloadable_url', '') },
          { fileName: 'Form 1', fileUrl: _.get(props.applicationDetails, 'signed_form1_downloadable_url', '') },
          { fileName: 'Form 2', fileUrl: _.get(props.applicationDetails, 'signed_form2_downloadable_url', '') }
        ]
        break
      }
      case PROGRAM_KEY.PSEG_LI: {
        list = [
          { fileName: 'Program T&C Document', fileUrl: _.get(props.applicationDetails, 'signed_tandc_form_downloadable_url', '') },
          { fileName: 'NYSERDA Incentive Application', fileUrl: _.get(props.applicationDetails, 'signed_form1_downloadable_url', '') },
          { fileName: 'PSEG Enrolment Form', fileUrl: _.get(props.applicationDetails, 'signed_application_form_downloadable_url', ''), type: 'csv' }
        ]
        break
      }
      case FAMILY_KEY.CT_ESS: {
        list = [
          { fileName: 'Enphase T&C Document', fileUrl: _.get(props.applicationDetails, 'signed_tandc_form_downloadable_url', '') },
          { fileName: 'Reservation of Funds Document', fileUrl: _.get(props.applicationDetails, 'signed_form1_downloadable_url', '') }
        ]
        break
      }
      case PROGRAM_KEY.GMP_ENPH: {
        list = [
          { fileName: 'Application Form', fileUrl: _.get(props.applicationDetails, 'signed_application_form_downloadable_url', '') }
        ]
        break
      }
      default:
        list = [
          { fileName: 'Program T&C Document', fileUrl: _.get(props.applicationDetails, 'signed_tandc_form_downloadable_url', '') },
          { fileName: 'Application Form', fileUrl: _.get(props.applicationDetails, 'signed_application_form_downloadable_url', '') },
          { fileName: 'Form 1', fileUrl: _.get(props.applicationDetails, 'signed_form1_downloadable_url', '') },
          { fileName: 'Form 2', fileUrl: _.get(props.applicationDetails, 'signed_form2_downloadable_url', '') }
        ]
    }
    forms = await getFormDetails(formFields, props.applicationDetails, props.utilityName)
    if (props.familyKey === FAMILY_KEY.CT_ESS) {
      forms = forms.filter(obj => obj.id !== FORM_IDS.ADDRESS2 || (obj.id === FORM_IDS.ADDRESS2 && obj.value !== ''))
    }
    setPdfList(list)
    setPdfUrl(list.find((obj) => obj.fileUrl) || list[0])
    setForms(forms)
    setLength(-1)
    setButtonDisable(true)
  }, [props.applicationDetails, props.programKey, props.utilityName, props.familyKey])

  const PdfToggle = () => (
    <Box className={classes.wrapper} style={{ width: '80%', flexWrap: 'wrap' }}>
      {pdfList.map(obj => {
        return (
          <>
            {obj.fileUrl &&
              <Box onClick={() => setPdfUrl(obj)} className={`${classes.pdfToggle} ${selectedPdf.fileName === obj.fileName ? classes.selectedPdf : ''}`}>
                <Icon src="pdfFile" />
                <Typography>{obj.fileName}</Typography>
              </Box>
            }
          </>
        )
      })}
    </Box>
  )

  const handleSiteClick = () => {
    const siteId = _.get(props.applicationDetails, 'site_id', '')
    siteId && window.open(Urls.getApiUrl(`admin/sites/${siteId}`), '_blank')
  }

  const handleRejectClose = () => {
    setRejectModal(false)
    setReason('')
  }

  const getApplicationStatus = (status) => {
    if (props.workflow === PROGRAM_WORKFLOW.API_FLOW) {
      return status === STATUS.APPROVED ? SITE_STATUS.APPLICATION_APPROVED : SITE_STATUS.APPLICATION_REJECTED
    }
    else if ((props.programKey === PROGRAM_KEY.PSEG_LI || props.programKey === PROGRAM_KEY.SWELL || props.familyKey === FAMILY_KEY.CT_ESS) && props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED) {
      return status === STATUS.APPROVED ? SITE_STATUS.APPLICATION_APPROVED : SITE_STATUS.APPLICATION_REJECTED
    }
    else if (props.programKey === PROGRAM_KEY.GMP_ENPH || props.programKey === PROGRAM_KEY.APS_RBP || props.programKey === PROGRAM_KEY.PSEG_LI) {
      return status === STATUS.APPROVED ? SITE_STATUS.SITE_APPROVED : SITE_STATUS.SITE_REJECTED
    }
    return status === STATUS.APPROVED ? SITE_STATUS.APPLICATION_APPROVED : SITE_STATUS.APPLICATION_REJECTED
  }

  const errorCb = (error, status, showModal) => {
    props.setLoading(false)
    if (status === STATUS.APPROVED && showModal) {
      setErrorModal(true)
      setErrorMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
    } else {
      props.errorCb()
    }
  }

  const updateApplicationStatus = (body, status) => {
    customerService.updateStatus(props.applicationId, body)
      .then(() => {
        props.setApplicationStatus(getApplicationStatus(status))
        props.setLoading(false)
        props.setApplicationId('')
        setPsegReferenceId('')
        props.getApplicationList(0, props.applicationStatus)
        props.successCb(status === STATUS.APPROVED ? 'Application approved successfully' : 'Application rejected successfully', props.applicationStatus)
      })
      .catch((error) => errorCb(error, status, true))
  }

  const updatePsegReferenceId = (payload, body, status) => {
    customerService.updateApplication(payload, 'put', props.applicationId)
      .then(res => {
        updateApplicationStatus(body, status)
      })
      .catch((error) => errorCb(error, status, false))
  }

  const handleSubmit = (status) => {
    status === STATUS.APPROVED ? setApproveModal(false) : setRejectModal(false)
    setReason('')
    props.setLoading(true)
    const body = {
      application_status: getApplicationStatus(status),
      message: status === STATUS.APPROVED ? '' : reason.trim(),
      last_modified_by: _.get(props.currentUser, 'email', ''),
      timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss')
    }
    if (status === STATUS.APPROVED) body.application_approval_date = moment.utc().format('YYYY-MM-DD HH:mm:ss')
    const payload = {
      site_id: _.get(props.applicationDetails, 'site_id', ''),
      utility_reference_id: psegReferenceId ? psegReferenceId.trim() : '',
      homeowner_info: _.get(props.applicationDetails, 'homeowner_info', {})
    }

    pushToDataLayer({ event: USERBEHAVIOURTRACKING, userID: props.currentUser.user_id, programID: _.get(props, 'applicationDetails.program_id', '') })
    if (props.programKey === PROGRAM_KEY.PSEG_LI && props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED && status === STATUS.APPROVED) {
      updatePsegReferenceId(payload, body, status)
    } else {
      updateApplicationStatus(body, status)
    }

  }

  const renderReasonModal = () => {
    const logHistory = _.get(props.applicationDetails, 'log_history', [])
    var list = []
    if (props.applicationStatus === SITE_STATUS.APPLICATION_REJECTED || props.programKey === PROGRAM_KEY.SWELL) {
      list = logHistory.filter(obj => obj.application_status === SITE_STATUS.APPLICATION_REJECTED)
    } else {
      list = logHistory.filter(obj => obj.application_status === SITE_STATUS.SITE_REJECTED)
    }
    const rejectedObj = _.last(list)
    const message = _.get(rejectedObj, 'message', '')

    return (
      <Box>
        <Box className={classes.reasonWrapper}><Typography className={classes.message}>{message}</Typography></Box>
        <AppButton className={classes.closeButton} text="Close" fill={false} onClick={() => setShowReason(false)} />
      </Box>
    )
  }

  const renderApproveModal = () => {
    return (
      <Box className={classes.modalWrapper}>
        <Typography className={classes.modalText}>Are you sure you want to approve the application?</Typography>
        <Box display="flex" className={classes.modalButtonGrp} style={{ margin: 0 }}>
          <AppButton className={classes.modalButton} text="Yes" onClick={() => handleSubmit(STATUS.APPROVED)} />
          <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => setApproveModal(false)} />
        </Box>
      </Box>
    )
  }

  const renderRejectModal = () => {
    return (
      <Box className={classes.modalWrapper}>
        <Typography className={classes.modalText}>Please provide a reason for rejection below.</Typography>
        <TextField
          classes={{ root: classes.textBox }}
          variant="outlined"
          multiline
          rows={4}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value)
          }}
        />
        <Box display="flex" className={classes.modalButtonGrp}>
          <AppButton className={classes.modalButton} text="Submit" disabled={_.isEmpty(reason.trim())} onClick={() => handleSubmit(STATUS.REJECTED)} />
          <AppButton className={classes.modalButton} text="Cancel" fill={false} onClick={handleRejectClose} />
        </Box>
      </Box>
    )
  }

  const renderErrorModal = () => {
    return (
      <Box className={classes.modalWrapper}>
        <ErrorOutlineOutlinedIcon fontSize="large" className={classes.errorIcon} />
        <Typography className={classes.errorText}>Please reject the application!</Typography>
        <br />
        <Typography className={classes.errorText}>{errorMessage}</Typography>
      </Box>
    )
  }

  const renderCSVDownload = () => {
    return <Box className={classes.downloadWrapper}>
      <Box>
        <Icon src="csvFile" />
        <Box className={classes.downloadContent}>
          <Typography>CSV File</Typography>
          <Typography>(PSEG Enrolment Form)</Typography>
        </Box>
      </Box>
    </Box>
  }

  return (
    <Box className={classes.detailContainer}>
      <Typography className={classes.title}>Application Details</Typography>
      {props.applicationId ?
        props.applicationStatus === SITE_STATUS.SITE_REJECTED && _.get(props.applicationDetails, 'application_status', '') === SITE_STATUS.SITE_SUBMITTED ? (<Typography className={classes.empty}>Application's status has changed. Please refresh the page.</Typography>)
          : (<>
            <Box className={classes.detailWrapper}>
              <Box className={classes.buttonGroup}>
                <PdfToggle />
                <Typography className={classes.siteButton} onClick={handleSiteClick}>Open Site Details on Enlighten</Typography>
              </Box>
              <Box className={`${classes.wrapper} ${classes.spaceBtw}`}>
                {
                  selectedPdf.type === 'csv'
                    ? <Box className={classes.pdfViewerWrapper}>
                      <Cards children={renderCSVDownload()} />
                      <Box className={classes.downloadButton} onClick={() => downloadFile(selectedPdf.fileUrl, 'blank')}>
                        <Icon src="download" />
                        <Typography>Download</Typography>
                      </Box>
                    </Box>
                    : <PdfViewer selectedPdf={selectedPdf} />
                }
                <FormFields handleAction={setLength} forms={forms} setButtonDisable={setButtonDisable} applicationStatus={props.applicationStatus} />
              </Box>
            </Box>
            <ApplicationFooter
              programKey={props.programKey}
              applicationStatus={props.applicationStatus}
              applicationDetails={props.applicationDetails}
              length={length}
              disableButton={disableButton}
              psegReferenceId={psegReferenceId}
              applicationId={props.applicationId}
              setPsegReferenceId={setPsegReferenceId}
              setApproveModal={setApproveModal}
              setRejectModal={setRejectModal}
              setShowReason={setShowReason}
              familyKey={props.familyKey}
            />
          </>)
        : (
          <Typography className={classes.empty}>
            {props.programKey === PROGRAM_KEY.PSEG_LI
              ? "Click on the Application ID_Site ID from the left pane to open the application"
              : "Click on the Application ID from the left pane to open the application"
            }
          </Typography>
        )}
      <CustomDialog open={approveModal} fullWidth maxWidth="xs" title="" content={renderApproveModal()} handleClose={() => setApproveModal(false)} />
      <CustomDialog open={rejectModal} fullWidth maxWidth="xs" title="" content={renderRejectModal()} handleClose={handleRejectClose} />
      <CustomDialog open={showReasonModal} fullWidth maxWidth="xs" title="Rejection Reason" className={classes.reasonModal} content={renderReasonModal()} handleClose={() => setShowReason(false)} />
      <CustomDialog open={showErrorModal} fullWidth maxWidth="xs" title="" content={renderErrorModal()} handleClose={() => { setErrorModal(false); setErrorMessage('') }} />
    </Box>
  )
}

ApplicationDetails.defaultProps = {
  applicationId: '',
  applicationDetails: {}
}

const mapStateToProps = ({ auth }) => {
  const { currentUser } = auth
  return { currentUser }
}

export default connect(mapStateToProps, {})(ApplicationDetails)